import React from 'react';

const TermsAndConditions: React.FC = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow">
                <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms and Conditions</h1>

                <div className="space-y-6 text-gray-700">
                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Acceptance of Terms</h2>
                        <p>
                            By accessing and using GymPe (the "Service"), you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use the Service.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Description of Service</h2>
                        <p>
                            GymPe provides gym management software for gym owners ("Tenants") to manage their members ("Members"), memberships, attendance, and communications.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">3. User Responsibilities (Gym Owners/Tenants)</h2>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
                            <li>You agree to use the Service in compliance with all applicable laws and regulations.</li>
                            <li>You represent that you have the necessary consents to store and process your Members' data.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Member Communications & WhatsApp Messaging</h2>
                        <p className="mb-2">
                            By adding Member information to GymPe, you verify that you have obtained explicit consent from the Member to receive communications, including via WhatsApp.
                        </p>
                        <p className="mb-2">
                            <strong>WhatsApp Permission Usage (whatsapp_business_messaging):</strong>
                        </p>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>
                                The Service uses the <code>whatsapp_business_messaging</code> permission to send WhatsApp messages to specific phone numbers.
                            </li>
                            <li>
                                This includes:
                                <ul className="list-circle pl-5 mt-1">
                                    <li>Sending transaction alerts (e.g., payment receipts, membership expiry).</li>
                                    <li>Sending attendance notifications.</li>
                                    <li>Sending gym updates and announcements.</li>
                                    <li>Sending marketing messages (where applicable and consented).</li>
                                </ul>
                            </li>
                            <li>
                                The Service may also use this permission to:
                                <ul className="list-circle pl-5 mt-1">
                                    <li>Upload and retrieve media associated with messages.</li>
                                    <li>Manage and get WhatsApp business profile information.</li>
                                    <li>Register phone numbers with Meta.</li>
                                    <li>Request analytics insights to improve the app (using aggregated and de-identified data).</li>
                                </ul>
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Data Privacy</h2>
                        <p>
                            We respect your privacy. Please refer to our <a href="/privacy-policy" className="text-blue-600 hover:underline">Privacy Policy</a> to understand how we collect, use, and share your data.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
